const setIsServerConnectableAction = ({ commit }, payload) => {
  commit('setIsServerConnectable', payload)
}

const setShowingSlideGridAction = ({ commit }, payload) => {
  commit('setShowingSlideGrid', payload)
}

const setIsWelcomePopupShowingAction = ({ commit }, payload) => {
  if (payload) {
    document.body.classList.add('no-scroll')
  } else {
    document.body.classList.remove('no-scroll')
  }

  commit('setIsWelcomePopupShowing', payload)
}

export default {
  setIsServerConnectableAction,
  setShowingSlideGridAction,
  setIsWelcomePopupShowingAction,
}
